import { BrowserRouter, Routes, Route, Switch } from "react-router-dom";
import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import MenuPaginas from './components/MenuPaginas/MenuPaginas';
import Pag from './components/Pag/Pag';
import Rubros from './components/Rubros/Rubros';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import Ceresos from "./components/Ceresos/Ceresos";
import Privada from "./components/Privada/Privada";
import Error404 from "./components/Error404/Error404";

function App() {
  return (
    <BrowserRouter >
      <Header/>
        <Routes>
          <Route exact path="/" element={ <Inicio /> } />
          <Route exact path="/Paginas/:pagina" element={ <MenuPaginas/> } />
          <Route exact path="/Pag/:pag" element={ <Pag/> } />
          <Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
          <Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
          <Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
          <Route exact path="/Ceresos" element={ <Ceresos/> } />
          <Route exact path="/Privada" element={ <Privada/> } />
          <Route exact path="/Agenda" element={ <Agenda/> } />
          <Route exact path="*" element={<Error404 /> } />
        </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
